import { render, staticRenderFns } from "./NuevaModificacionDatosPersonales.vue?vue&type=template&id=741734ab"
import script from "./NuevaModificacionDatosPersonales.vue?vue&type=script&lang=js"
export * from "./NuevaModificacionDatosPersonales.vue?vue&type=script&lang=js"
import style0 from "./NuevaModificacionDatosPersonales.vue?vue&type=style&index=0&id=741734ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports